//
export default [
    {
        name: 'is_cyclic',
        type: 'select',
        props: {
        	clearable: true,
        	items: [
        		{
        			text: 'No',
        			value: false,
        		},
        		{
        			text: 'Si',
        			value: true,
        		},
        	],
            label: 'Ciclico',
        },
    },
]
